//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: String
  }
}



// WEBPACK FOOTER //
// ./~/.2.0.17@vux/src/components/group/index.vue